import { Page, Layout } from "@shopify/polaris";

import CheckoutSettings from "../componens/checkoutSettings";
import TrafficArmorSettings from "../componens/trafficArmorSettings";


export default function Settings() {
  return (
    <Page>
      <Layout>
        <Layout.Section>
          <CheckoutSettings />
          <TrafficArmorSettings />
        </Layout.Section>
      </Layout>
    </Page>
  );
}
